import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { MenuItemContainer } from '../components/menuItemContainer';
import { useSocketSend } from '../context/webSocket/webSocketContext';
import { thunkSetActivePanel } from '../redux/actions/panelsActions';
import { useAppDispatch } from '../redux/store';
import { ALL_PANEL_BUTTON_PROPERTIES } from './rightPanelButton';
export const HiddenPanelMenuItem = ({ panelType, closeMenu }) => {
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    const { label, shownIcon } = ALL_PANEL_BUTTON_PROPERTIES[panelType];
    const onClick = useCallback(() => {
        closeMenu();
        dispatch(thunkSetActivePanel(panelType, socketSend, false));
    }, [dispatch, panelType, socketSend, closeMenu]);
    return _jsx(MenuItemContainer, { label: label, svgIconComponent: shownIcon, onClick: onClick, closeMenu: closeMenu });
};
